import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const ROTA_SUMMARY_TABLE_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
